export default __webpack_public_path__ + "static/media/ic_pakistan.7d7960fc.svg";